export default __webpack_public_path__ + "img/a8d235befe4d15b11a21437f0c31d967.svg";